<template>
  <div class="hint-main" style="width: 100%;">
    <div class="info-edit-option" :class="[!isExample && !isVerb ? 'flex-start' : '']">
      <div :class="['menu', infoEditOption === 0 ? 'active' : '']" @mousedown.prevent @click="infoEditOption = 0">填写贴士</div>
      <div :class="['menu', infoEditOption === 1 ? 'active' : '']" @mousedown.prevent @click="infoEditOption = 1" v-if="isExample">大牛案例</div>
      <div :class="['menu', infoEditOption === 2 ? 'active' : '']" @mousedown.prevent @click="infoEditOption = 2" v-if="isVerb">常用动词</div>
    </div>
    <!-- 填写贴士 -->
    <div class="info-item" v-show="infoEditOption === 0">
      <!-- 填写贴士 -->
      <div class="model tips">
        <div v-show="tipsShow" style="padding: 10px 0 20px;">
          <el-select class="tips-select" value-key="id" v-model="faqActive" placeholder="请选择" @change="getFaq">
            <el-option v-for="(item, index) in faqOptions" :key="index" :label="item.title" :value="item"/>
          </el-select>
          <div class="tips-content">
            <div class="tips-menu" v-for="(item, num) in faqs" :key="num">
              <div :class="['tips-menu-title', item.show ? 'show' : '']" @click="faqsShow(num)">
                <span class="text-overflow">{{item.headerline}}</span>
                <i class="iconfont iconchevron-down"></i>
              </div>
              <div class="tips-menu-content" v-html="item.desc" v-show="item.show"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 查看案例 -->
    <div class="info-item" v-show="infoEditOption === 1">
      <!-- 大牛简历 -->
      <div class="model case">
        <div class="case-select">
          <div>
            <el-select class="tips-select" value-key="name" v-model="exampleOptionsActive" placeholder="请选择" @change="exampleOptionsChange">
              <el-option v-for="item in exampleOptions" :key="item.name" :label="item.name" :value="item"/>
            </el-select>
          </div>
          <div>
            <el-select class="tips-select" placeholder="请选择" v-model="exampleTagActive" @change="exampleWorkTagChange" v-if="cvDetailType.lang==='cn'&& cvDetailType.type==='works' && exampleOptionsActive.type ==='workExamples'">
              <el-option v-for="item in exampleOptionsActive.sub" :key="item.id" :label="item.name" :value="item.id"/>
            </el-select>
            <el-select class="tips-select" placeholder="请选择" v-model="exampleTagActive" @change="exampleTagChange" v-else>
              <el-option v-for="item in exampleOptionsActive.sub" :key="item" :label="item" :value="item"/>
            </el-select>
          </div>
        </div>
        <div class="case-content">
          <template v-if="!examples || !examples.length">
            <div class="case-menu-content" style="text-align: center; padding: 20px;color: #9C9C9C;">
              没有更多案例
            </div>
          </template>
          <template v-else>
            <div class="case-menu" v-for="(item, index) in examples" :key="index">
              <!-- <div class="case-menu-title">{{item.company}}</div> -->
              <div style="background: #F9F9F9; padding: 20px;" class="case-menu-content" v-html="item.detail"
                   :style="{'margin-bottom': editData.moduleType === 'works' ? '10px' : '0'}"></div>
            </div>
            <div class="case-more-btn" @click="applets">查看更多大牛案例</div>
          </template>
        </div>
      </div>
    </div>
    <!-- 常用动词 -->
    <div class="info-item" v-show="infoEditOption === 2">
      <!-- 大牛简历 -->
      <div class="model case">
        <div class="case-select">
          <div>
            <el-select class="tips-select" v-model="verbTagActive" placeholder="请选择">
              <el-option v-for="item in verbsOptions" :key="item" :label="item" :value="item"/>
            </el-select>
          </div>
          <div>
            <el-select class="tips-select" v-model="verbOptionActive" placeholder="请选择">
              <el-option v-for="item in verbsLangOptions" :key="item" :label="item" :value="item"/>
            </el-select>
          </div>
        </div>
        <div class="case-content">
          <div class="verb" v-if="cvDetail.basic_info">
            <template
                v-if="cvDetail.basic_info.lang === 'cn' || (cvDetail.basic_info.lang === 'en' && verbOptionActive === '英文')">
              <div class="menu" v-for="(item, index) in ~~(verbs.length / 2)" :key="index">
                <p>{{verbs[(2 * index)][verbOptionActive === '英文' ? 'en' : 'cn']}}</p>
                <p v-if="2 * index + 1 <= verbs.length">{{verbs[2 * index + 1][verbOptionActive === '英文' ? 'en' :
                  'cn']}}</p>
              </div>
            </template>
            <template v-else>
              <div class="menu" v-for="(item, index) in verbs" :key="index">
                <p>{{item.en}}</p>
                <p>{{item[verbOptionActive === '英文' ? 'en' : 'cn']}}</p>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
	import { mapState, mapActions } from 'vuex'
	import api from '@/api'
	import { routerTo } from '../../../../../assets/js/util'

	const verbsOptions = [ '个人成就', '教授、指导他人', '行政、管理能力', '领导能力', '人际沟通能力', '组织、计划能力', '创造、创新能力', '研究、逻辑分析能力', '金融、财经知识', '技术能力' ]
	const exampleOptions = [{
      type: 'edus', name: '教育经历', sub: [ '全部' ]
    },{
			type: 'works',
			name: '全职工作经历',
			sub: [ '咨询', '银行', '财税/会计/审计', '地产', '客服', '行政', '人力资源', '销售', '医护', '运营', '产品', '技术', '教师', '金融/投行/证券', '市场/渠道' ]
		},{
			type: '',
			name: '实习经历',
			sub: [ '咨询', '银行', '财税/会计/审计', '地产', '客服', '行政', '人力资源', '销售', '医护', '运营', '产品', '技术', '教师', '金融/投行/证券', '市场/渠道' ]
		},
		{ type: '', cvType :'orgs', name: '组织及活动经历', sub: [ '公益', '赛事', '学生会' ] },
		{ type: '', cvType :'extras', name: '其他', sub: [ '全部' ] },
		{ type: '', cvType :'project_experience', name: '项目经历', sub: [ '全部' ] },
		{ type: '', cvType :'reasearch_experience', name: '研究经历', sub: [ '全部' ] },
		{ type: '', cvType :'personal_summary', name: '个人总结', sub: [ '全部' ] }
	]
	export default {
		name: 'hint',
		data () {
			return {
				// 动词
				verbsOptions, // verbs options
				verbsLangOptions: [],
				verbTagActive: verbsOptions[0], // 动词选中
				verbOptionActive: '中文', // 选中语言
				verbs: [], // 动词详情列表

				// 案例
				exampleOptions,
        exampleOptionsActive: exampleOptions[0],
				exampleTagActive: '全部',
				examples: [], // 案例内容列表

				faqActive: {}, // 选中
				faqs: [],

				editData: {},
				infoEditOption: 0,


				isExample: true, // 显示大牛案例
				isVerb: true, // 常用动词显示
				isQuestion: false, // 问题是否隐藏f ot t
				isMore: true, // 显示产看更多
				showText: '', // 显示的文本

				noCheck: false,
				tab: 1,

				suggestShow: true,
				tipsShow: true,
				fractionShow: true,

        infoShow: false,
        cvDetailType:{
          type:'',
          lang:'',
        }
			}
		},
		computed: {
			...mapState('cvsEditor', [ 'cvToken' ]),
			...mapState('cvs', [ 'cvs', 'cv', 'cvPages', 'downloadCv', 'check', 'editorCvToken' ]),
			...mapState('me', [ 'publicKey', 'isMembership' ]),
			...mapState('editor', [ 'cvDetail', 'cvToken', 'faqOptions', 'currentInfo' ]),
		},
		watch: {
			cvDetail: {
				deep: true,
				immediate: true,
				handler (cvDetail) {
					let { basic_info } = cvDetail
					// 设置语言下拉框
					let verbsLangOptions = [
						'中文'
					]
					if (basic_info.lang === 'en') {
						verbsLangOptions.push('英文')
					}
					this.verbsLangOptions = verbsLangOptions
				}
			},
			// exampleTagActive () {
			// 	this.getExample()
			// }
    },
    created(){
      if(this.isExample){
        this.infoEditOption = 1;
      }
      //检测是否需要同步显示大牛案例tab
      let { type } = this.currentInfo;
      let { lang } = this.cvDetail.basic_info;
      let exampleIndex = 0;
      this.exampleOptions.forEach((item,index)=>{
        if(item.type === type || item.cvType === type){
          exampleIndex = index
        }
      })
      this.exampleOptionsActive =  this.exampleOptions[exampleIndex];
      //同步当前模块类型及语言类型
      this.cvDetailType = {
        type,
        lang,
      };
      if(type ==='works' && lang ==='cn'){
        //嗷嗷
        // this.getWorkExamples({
        //   profession_id:'',
        //   ability_id:''
        // });
      }
    },
		async mounted () {
			// 获取首屏动词
			// this.verbTagChange(verbsOptions[0])
			// 获取faqoptions
			// this.initFaqOptions()
			// 获取案例
			// this.getExample()
		},
		methods: {
			...mapActions('editor', [ 'getFaqOption' ]),
			// 展开影藏faq
			faqsShow (index) {
				let faqs = this.faqs
				faqs[index].show = !faqs[index].show
				this.faqs = [
					...faqs
				]
			},
			// 获取faq
			async getFaq () {
				let res = {}
				let params = {
					faq_id: this.faqActive.id,
					faq_name: this.faqActive.title
				}
				res = await api.cvsEditor.getFaq(params)
				if (res.code !== 1000) return false
				this.faqs = res.data.faqs
			},
			async initFaqOptions () {
				let res = await this.getFaqOption()
				if (res) {
					this.faqs = res.data.faqs
					if (this.faqOptions && this.faqOptions.length) this.faqActive = this.faqOptions[0]
				}
			},
			// 获取动词 data:string
			async verbTagChange (data) {
				let res = {}
				res = await api.cvsEditor.getVerbs({ verb_type: data })
				if (res.code !== 1000) {
					this.$message.error('常用动词获取失败')
					return false
				}
				this.verbs = res.data.verbs || []
			},
			// 案例
			exampleOptionsChange (data) {
        this.exampleTagActive = data.sub[0]
        if(data.type === "workExamples"){
          //获取独有的work参数
          // this.getWorkExamples({
          //   profession_id: data.id,
          //   ability_id: ''
          // })
        }else{
          // this.getExample()
        }
        console.log(data)
			},
      exampleTagChange (data) {
				// this.getExample()
      },
			// 获取
			async getExample () {
				let params = {
					example_name: this.exampleOptionsActive.name,
					example_tag: this.exampleTagActive,
					cv_type: this.cvDetail.basic_info.cv_type
				}
        let res = await api.cvsEditor.getExamples(params)
				if (res.code === 1000) {
          this.examples = res.data.examples
        }
			},
			// 产看更多案例
			applets () {
				routerTo(`/jianlimoban`, '_blank')
				// this.$store.dispatch('app/setAlertData', { show: true, type: 'applets' })
      },
      //类型
      exampleWorkTagChange(id){
        //获取独有的work参数
        // this.getWorkExamples({
        //   profession_id: this.exampleOptionsActive.id,
        //   ability_id: this.exampleTagActive
        // })

      },
      //获取中文简历-工作经历
      async getWorkExamples(query){
        try {
          let { profession_id, ability_id} = query;
          let res = await api.cvs.getWorkExamples(this.cvToken, query);
          if(res.code === 1000){
            // professions 左边大分类, abilities右边小分类, examples内容
            let { professions, abilities, examples} = res.data;
            if(!profession_id){
              //首次进入
              professions.forEach(item=>{
                item.type = 'workExamples';
                item.sub = [];
              })
              professions[0].sub = abilities;
              this.exampleOptionsActive = professions[0];
              this.exampleOptions = professions.concat(this.exampleOptions);
            }else if(!ability_id){
              // 切换大类
              this.exampleOptions.forEach(item=>{
                if(item.id === profession_id){
                  item.sub = abilities;
                  this.exampleOptionsActive = item;
                  this.exampleTagActive = abilities[0].id
                }
              })
            }
            this.examples = examples;
          }
        } catch (error) {

        }
      },
		}
	}
</script>
<style lang="scss" scoped>
  @import 'hint';
</style>
